import { Injectable } from '@angular/core';
import { ConfigurationService } from './configuration.service';

@Injectable({
  providedIn: 'root',
})
export class EnumService {
  private readonly _enums: any;

  constructor(configuration: ConfigurationService) {
    this._enums = configuration.enums;
  }

  public getEnum(name: string): any {
    return this._enums[name];
  }

  public getEnumArray(name: string): any[] {
    const enumObject = this.getEnum(name);
    return Object.keys(enumObject).map((k) => enumObject[k]);
  }

  public getEnumArrayExcluded(enumName: string, ...excluded: string[]): any[] {
    const enumArray = this.getEnumArray(enumName);
    return enumArray.filter((e) => excluded.indexOf(e.Key) === -1);
  }
}
